module.exports = "/_next/static/images/26ee8ae1ec5d056e755ad914ef75801a-product-information-lg-1x.jpg";